window.tinymce.PluginManager.add('externalmediaembed', function (editor) {
  var confirmService = editor.getParam('confirm');

  editor.ui.registry.addButton('externalmediaembed', {
    icon: 'embed-page',
    tooltip: 'Insert External Media',
    onAction: function () {
      confirmService
        .ask('confirm.assign_media.title', null, {
          componentName: 'external-media-embed',
        })
        .then((ok) => {
          if (!ok) {
            return;
          }

          var id = ok.externalMediaId;
          var type = ok.externalMediaType;

          if (type !== 'iframe') {
            editor.insertContent(
              `<externalmediaembed type="${type}" class="mceNonEditable mce-${type}" data-id="${id}" />`,
            );
          } else {
            editor.insertContent(
              `<iframe src="${id}" class="mceNonEditable mce-${type}"></iframe>`,
            );
          }
        });
    },
  });
});
